export type OffsetMap = {
  toCodePoint: (utf16: number) => number
  toUtf16: (codePoint: number) => number
}

export function offsetMap(text: string): OffsetMap {
  const astralUtf16: number[] = []
  let codePoint = 0
  for (let index = 0; index < text.length; index += 1) {
    const unit = text.charCodeAt(index)
    if (unit >= 0xd800 && unit <= 0xdbff && index + 1 < text.length) {
      astralUtf16.push(index)
      index += 1
    }
    codePoint += 1
  }
  const astralCodePoint = astralUtf16.map((position, order) => position - order)
  const countBelow = (sorted: number[], value: number) => {
    let low = 0
    let high = sorted.length
    while (low < high) {
      const middle = (low + high) >> 1
      if (sorted[middle] < value) low = middle + 1
      else high = middle
    }
    return low
  }
  return {
    toCodePoint: (utf16) => utf16 - countBelow(astralUtf16, utf16),
    toUtf16: (point) => point + countBelow(astralCodePoint, point),
  }
}
